import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from "react-i18next";

const OEBrandsCarousol = ({
    brandsData = [],
    selectedOEBrandsArray,
    setSelectedOEBrandsArray,
    setPage,
    setAFMSelectedBrands,
    setSelectedBrandsArray,
    isSticky,
    setSelectedBrandTags,
    isTrue,
    onChange,
}) => {
    const { gdcURL } = useContext(ConfigContext);
    const { t } = useTranslation();

    const [selectedBrands, setSelectedBrands] = useState([]);

    useEffect(() => {
        setSelectedBrands(selectedOEBrandsArray || []);
    }, [selectedOEBrandsArray]);

    const brands = brandsData || [];

    // const toggleBrand = (brandName) => {
    //     let updated;

    //     if (selectedBrands.includes(brandName)) {
    //         updated = selectedBrands.filter((b) => b !== brandName);
    //     } else {
    //         updated = [...selectedBrands, brandName];
    //     }

    //     setSelectedBrands(updated);
    //     setSelectedOEBrandsArray(updated);

    //     setPage(1);
    //     setAFMSelectedBrands([]);
    //     setSelectedBrandsArray([]);
    //     setSelectedBrandTags([]);

    //     window.scrollTo({ top: 0, behavior: "smooth" });
    // };


    const toggleBrand = (brandName) => {
        const updated = selectedBrands.includes(brandName)
            ? selectedBrands.filter((brand) => brand !== brandName)
            : [...selectedBrands, brandName];

        setSelectedBrands(updated);

        if (onChange) {
            onChange(updated);
        } else {
            setSelectedOEBrandsArray(updated);
            setPage(1);
            setAFMSelectedBrands([]);
            setSelectedBrandsArray([]);
            setSelectedBrandTags([]);
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 10 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 4 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 3 },
    };

    const ButtonGroup = ({ next, previous, ...rest }) => {
        const {
            carouselState: { currentSlide },
        } = rest;

        return (
            <div className="carousel-button-group">
                <button
                    style={{
                        padding: "2px 6px",
                        position: "absolute",
                        left: 0,
                        top: "8px",
                        marginLeft: isTrue ? "-20px" : "-40px",
                    }}
                    className={
                        currentSlide === 0
                            ? "btn btn-outline-dark btn-sm disable"
                            : "btn btn-outline-dark btn-sm"
                    }
                    onClick={previous}
                >
                    <i className="fas fa-chevron-left"></i>
                </button>

                <button
                    style={{
                        padding: "2px 6px",
                        position: "absolute",
                        right: 0,
                        top: "8px",
                        marginRight: "-30px",
                    }}
                    className="btn btn-outline-dark btn-sm"
                    onClick={next}
                >
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div>
        );
    };

    if (!brands?.length) return null;

    return (
        <>
            {!isSticky && (
                <>
                    <h5 className="text-muted">Genuine Brands</h5>

                    {selectedBrands.length > 0 && (
                        <div style={{ marginBottom: "10px" }}>
                            <h6>{t("selected_filters")}</h6>

                            {selectedBrands.map((brand) => (
                                <span
                                    key={brand}
                                    onClick={() => toggleBrand(brand)}
                                    className="badge badge-pill mr-2"
                                    style={{
                                        backgroundColor: "#e9e9e9",
                                        cursor: "pointer",
                                        padding: "6px 10px",
                                    }}
                                >
                                    {brand}
                                    <i
                                        className="fas fa-times-circle"
                                        style={{ marginLeft: "5px" }}
                                    ></i>
                                </span>
                            ))}
                        </div>
                    )}
                </>
            )}

            <div style={{ position: "relative", background: "#fff" }}>
                <Carousel
                    arrows={false}
                    renderButtonGroupOutside={brands.length > 10}
                    customButtonGroup={<ButtonGroup />}
                    responsive={responsive}
                    swipeable
                    draggable
                    showDots={false}
                    infinite={false}
                    keyBoardControl
                    transitionDuration={500}
                    containerClass="carousel-container"
                    itemClass="carousel-item-padding-10-px"
                >
                    {[...brands]
                        .sort(
                            (a, b) =>
                                selectedBrands.includes(b.stock_brand_name) -
                                selectedBrands.includes(a.stock_brand_name)
                        )
                        .map((brand, index) => (
                            <div
                                key={`${brand.stock_brand_name}-${index}`}
                                onClick={() => toggleBrand(brand.stock_brand_name)}
                                style={{
                                    cursor: "pointer",
                                    height: "40px",
                                    width: "80px",
                                    textAlign: "center",
                                    border: selectedBrands.includes(brand.stock_brand_name)
                                        ? "1px solid #cc000b"
                                        : "1px solid transparent",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <ImageWithFallback
                                    src={`${gdcURL}/make_logo/${brand?.MFA_ID}.png`}
                                    alt={brand?.stock_brand_name}
                                    fallbackText={brand?.stock_brand_name}
                                />
                            </div>
                        ))}
                </Carousel>
            </div>
        </>
    );
};

const ImageWithFallback = ({ src, alt, fallbackText }) => {
    const [imgError, setImgError] = useState(false);

    return (
        <div
            style={{
                width: "100%",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {imgError ? (
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "10px",
                        padding: "5px",
                        wordBreak: "break-word",
                    }}
                >
                    {fallbackText}
                </div>
            ) : (
                <img
                    draggable="false"
                    style={{ height: "30px" }}
                    src={src}
                    alt={alt}
                    onError={() => setImgError(true)}
                />
            )}
        </div>
    );
};

export default OEBrandsCarousol;